import { render, staticRenderFns } from "./alipay-data.vue?vue&type=template&id=550dd04c"
import script from "./alipay-data.vue?vue&type=script&lang=ts"
export * from "./alipay-data.vue?vue&type=script&lang=ts"
import style0 from "./alipay-data.vue?vue&type=style&index=0&id=550dd04c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports